import React from 'react';
export var UserContext = React.createContext({ isProxyUser: false });
